import { FunctionComponent, useCallback, useRef } from "react";
import { ElasticTag } from "../../../../modules/graphql/api.generated";
import { FocusableComponentLayout, FocusContext, useFocusable } from "../../../../modules/spatialNavigation";
import * as styles from "./styles.module.scss";
import TagItem from "./TagItem/tagItem";

const TagRowComponent: FunctionComponent<{ tags: ElasticTag[] }> = ({ tags }) => {
  const offsetLeftRef = useRef<any>(null);
  const scrollingRef = useRef<any>(null);
  const { ref, focusKey, focused } = useFocusable({
    focusBoundaryDirections: ["left"],
    autoRestoreFocus: true,
    isFocusBoundary: true,
  });
  const onAssetFocus = useCallback(
    (l: FocusableComponentLayout, index: number) => {
      offsetLeftRef.current = l;
      // because width of tags are different according to their characters
      scrollingRef.current.style.transform = `translateX(${index > 0 ? l.node.parentElement?.clientWidth! - l.left - l.width : 0}px)`;
      scrollingRef.current.style["-webkit-transform"] =
        `translateX(${index > 0 ? l.node.parentElement?.clientWidth! - l.left - l.width : 0}px)`;
    },
    [scrollingRef],
  );

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref}>
        <div className={styles.scrollingContainer + " " + styles.rowBox} ref={scrollingRef}>
          {tags &&
            tags.length > 1 &&
            tags.map((tag, index) => (
              <TagItem
                onFocus={(l, e: ElasticTag) => onAssetFocus(l, index)}
                data={tag}
                focusKey={`tag-${index}`}
                key={`tag-${index}`}
              />
            ))}
        </div>
      </div>
    </FocusContext.Provider>
  );
};
export default TagRowComponent;
